import React from "react";
import { Analytics } from "@vercel/analytics/react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import { Toaster } from "react-hot-toast";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard_recruiter from "./pages/Dashboard_recruiter";
import Profile from "./pages/Profile";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import ByePage from "./pages/ByePage";
import SavedCandidates from "./pages/SavedCandidates";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import JobDetails from "./pages/JobDetails";
import JobRankings from "./pages/JobRankings";
import JobCriteriaSimulator from "./pages/JobCriteriaSimulator";
import Jobs from "./pages/Jobs";
import JobCandidateScan from "./pages/JobCandidateScan";
import ScanHistory from "./pages/ScanHistory";
import Candidates from "./pages/Candidates";
import CandidateProcesses from "./pages/CandidateProcesses";
import InboxToShortlist from "./pages/InboxToShortlist";
import Help from "./pages/Help";
import FAQ from "./pages/FAQ";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import AiDisclaimer from "./pages/AiDisclaimer";
import EmailOAuthCallback from "./pages/EmailOAuthCallback";

export default function App() {
  return (
    <>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-100">

            {/* PAGE CONTENT */}
            {<div>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard_recruiter" element={<Dashboard_recruiter />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/rankings" element={<JobRankings />} />
                <Route path="/jobs/:jobId" element={<JobDetails />} />
                <Route path="/jobs/:jobId/rankings" element={<JobRankings />} />
                <Route path="/jobs/:jobId/criteria-simulator" element={<JobCriteriaSimulator />} />
                <Route path="/jobs/:jobId/scan-library" element={<JobCandidateScan />} />
                <Route path="/bulk-scan" element={<JobCandidateScan />} />
                <Route path="/scan-history" element={<ScanHistory />} />
                <Route path="/reports" element={<Navigate to="/profile?section=reports" replace />} />
                <Route path="/candidates" element={<Candidates />} />
                <Route path="/candidate-processes" element={<CandidateProcesses />} />
                <Route path="/inbox-to-shortlist" element={<InboxToShortlist />} />
                <Route path="/help" element={<Help />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfUse />} />
                <Route path="/ai-disclaimer" element={<AiDisclaimer />} />
                <Route path="/email-oauth-callback" element={<EmailOAuthCallback />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/upgrade" element={<Navigate to="/profile?section=upgrade" replace />} />
                <Route path="/subscription-success" element={<SubscriptionSuccess />} />
                <Route path="/bye" element={<ByePage />} />
                <Route path="/saved_candidates" element={<SavedCandidates />} />
                <Route path="/verify_email" element={<VerifyEmail />} />
                <Route path="/forgot_password" element={<ForgotPassword />} />
                <Route path="/reset_password" element={<ResetPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
              </Routes>
            </div>}

          </div>
        </Router>
      </AuthProvider>
      <Toaster
        position="top-center"       // center horizontally at top
        reverseOrder={false}
        toastOptions={{
          duration: 5000,           // 5 seconds
          style: {
            minWidth: '300px',
            maxWidth: '500px',
            fontSize: '16px',
            color: '#fff',
            background: '#1f2937',  // dark background
            padding: '16px 24px',
            borderRadius: '12px',
            boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
            textAlign: 'center',
          },
          success: {
            style: {
              background: '#4ade80',  // green for success
              color: '#000',
            }
          },
          error: {
            style: {
              background: '#f87171',  // red for error
              color: '#000',
            }
          },
          loading: {
            style: {
              background: '#60a5fa',  // blue for loading
              color: '#000',
            }
          }
        }}
      />
      <Analytics />
    </>
  );
}
